import React, { useContext, useState } from 'react'
import OTP from '../../component/home/otpdealer/Otp'
import { useLocation, useNavigate } from 'react-router-dom';
import { EmailOtp, SubmitEmail } from '../../services/OnbordingService';
import { AppContext } from '../../AppContext';

export default function OtpContainer() {
    const navigate = useNavigate();
    const { setCurrentStep, ordValue, setOrdValue } = useContext(AppContext);
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorSucess, setErrorSucess] = useState(false);
    const location = useLocation();
    const email = location.state?.email;

    const baseURL = window.location.origin;

    const handleChange = (e) => {
        const value = e.target.value;

 
        if (/^\d{0,6}$/.test(value)) {
            setOtp(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

    
        const trimmedOtp = otp.trim();

        if (trimmedOtp.length !== 6) {
            setError('OTP must be exactly 6 digits');
            setErrorSucess(false);
            return;
        }

        setLoading(true);

        try {
            const payload = {
                eotp: trimmedOtp,
                gotp: ordValue,
            };

            const response = await EmailOtp(payload);

            if (response) {
                setCurrentStep(3);
                navigate("/newApplicationPage", { state: { email } });
            }

        } catch (error) {
            if (error.response && error.response.data && error.response.data.description) {
                setError(error.response.data.description);
                setErrorSucess(false);
            } else {
                setError("An unexpected error occurred. Please try again later.");
                setErrorSucess(false);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitResendOtp = async (e) => {
        setLoading(true);
        setError(" ");
        setErrorSucess(false);
        try {
            const payload = {
                email: email,
                url: baseURL
            };
            const response = await SubmitEmail(payload);
            if (response) {
                setError("Resend OTP Code Successfully.");
                setOrdValue(response.ord);
                setErrorSucess(true);
            }
        } catch (error) {
            setError("Failed to resend OTP. Please try again.");
            setErrorSucess(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <OTP
                otp={otp}
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                handleSubmitResendOtp={handleSubmitResendOtp}
                error={error}
                loading={loading}
                errorSucess={errorSucess}
            />
        </div>
    );
}
